import { createClient } from '@connectrpc/connect'
import { create } from '@bufbuild/protobuf'
import {
  FileService,
  SearchFilesRequestSchema,
  type SearchFilesResponse,
} from '@puppycad/proto'
import { grpcWebTransport } from './transport/grpc-web-transport'

const fileClient = createClient(FileService, grpcWebTransport)

export interface SearchFilesParams {
  query?: string
  kinds?: string[]
  page?: number
  limit?: number
}

export async function searchFiles(params: SearchFilesParams = {}): Promise<SearchFilesResponse> {
  return await fileClient.searchFiles(
    create(SearchFilesRequestSchema, {
      query: params.query ?? '',
      kinds: params.kinds ?? [],
      page: params.page ?? 1,
      limit: params.limit ?? 20,
    })
  )
}
